module.exports = __webpack_public_path__ + "static/young-mounters-5bc1c116e55e7d55aec5b38f5bfde5f3.png";